export default {
  GET_ERROR: {
    title: 'There was an issue fetching your health documents'
  },
  UPLOAD_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue uploading your file'
  },
  UPLOAD_SIZE_ERROR: {
    severity: 'error' as 'error',
    title: 'Invalid file size'
  },
  UPLOAD_TYPE_ERROR: {
    severity: 'error' as 'error',
    title: 'Invalid file type'
  },
  REMOVE_ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue removing your file'
  }
};
